module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-5.6befba08.svg";